import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { 
  Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin, Youtube, Send, Globe, MessageCircle
} from "lucide-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

export const Footer = () => {
  const [email, setEmail] = useState("");

  const handleNewsletter = (e) => {
    e.preventDefault();
    if (email) {
      toast.success("Thank you for subscribing to our newsletter!");
      setEmail("");
    }
  };

  return (
    <footer className="bg-[#002147] text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_b5435c93-033f-4e57-8193-8df477e3abd8/artifacts/p9jfe1zg_358693407_106257442535698_4391661366190125414_n.jpg" 
                alt="School Logo" 
                className="w-10 h-10 object-contain rounded-full"
              />
              <h3 className="text-lg font-bold">YCP School</h3>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Young Christian Preparatory School/ JHS - Excellence in Education Since 1970
            </p>
            <div className="flex gap-3">
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                <Facebook size={18} />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                <Twitter size={18} />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                <Instagram size={18} />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                <Linkedin size={18} />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                <Youtube size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/announcements" className="hover:text-white transition-colors">Announcements</Link></li>
              <li><Link to="/events" className="hover:text-white transition-colors">Events</Link></li>
              <li><Link to="/staff" className="hover:text-white transition-colors">Staff Directory</Link></li>
              <li><Link to="/gallery" className="hover:text-white transition-colors">Photo Gallery</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact - Main & Annex Campus */}
          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            
            {/* Main Campus */}
            <div className="mb-4">
              <h5 className="text-[#FF6B00] font-medium text-sm mb-2">Main Campus</h5>
              <ul className="space-y-1.5 text-xs text-gray-400">
                <li className="flex items-center gap-2">
                  <MapPin size={12} className="text-[#FF6B00] flex-shrink-0" />
                  P.O. Box 682, Takoradi
                </li>
                <li className="flex items-center gap-2">
                  <Phone size={12} className="text-[#FF6B00] flex-shrink-0" />
                  TEL: (+233-31-22347)
                </li>
                <li className="flex items-center gap-2">
                  <Phone size={12} className="text-[#FF6B00] flex-shrink-0" />
                  Mobile: (+055-2184037)
                </li>
                <li className="flex items-center gap-2">
                  <MessageCircle size={12} className="text-[#FF6B00] flex-shrink-0" />
                  WhatsApp: (+055-2184037)
                </li>
                <li className="flex items-center gap-2">
                  <Mail size={12} className="text-[#FF6B00] flex-shrink-0" />
                  <a href="mailto:main@ycpschool.com" className="hover:text-white">main@ycpschool.com</a>
                </li>
              </ul>
            </div>
            
            {/* Annex Campus */}
            <div>
              <h5 className="text-[#FF6B00] font-medium text-sm mb-2">Annex Campus</h5>
              <ul className="space-y-1.5 text-xs text-gray-400">
                <li className="flex items-center gap-2">
                  <MapPin size={12} className="text-[#FF6B00] flex-shrink-0" />
                  P.O. Box 682, Lagos Town
                </li>
                <li className="flex items-center gap-2">
                  <Phone size={12} className="text-[#FF6B00] flex-shrink-0" />
                  TEL: (+233-31-22347)
                </li>
                <li className="flex items-center gap-2">
                  <Phone size={12} className="text-[#FF6B00] flex-shrink-0" />
                  Mobile: (+055-2184037)
                </li>
                <li className="flex items-center gap-2">
                  <MessageCircle size={12} className="text-[#FF6B00] flex-shrink-0" />
                  WhatsApp: (+055-2184037)
                </li>
                <li className="flex items-center gap-2">
                  <Mail size={12} className="text-[#FF6B00] flex-shrink-0" />
                  <a href="mailto:annex@ycpschool.com" className="hover:text-white">annex@ycpschool.com</a>
                </li>
              </ul>
            </div>
          </div>

          {/* Newsletter & Management */}
          <div>
            <h4 className="font-semibold mb-4">Newsletter</h4>
            <p className="text-sm text-gray-400 mb-4">
              Subscribe to receive updates and news
            </p>
            <form onSubmit={handleNewsletter} className="flex gap-2 mb-6">
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-white/10 border-white/20 text-white placeholder:text-gray-500"
              />
              <Button type="submit" className="bg-[#FF6B00] hover:bg-[#E65C00]">
                <Send size={16} />
              </Button>
            </form>
            
            {/* Management Contacts */}
            <div>
              <h5 className="text-[#FF6B00] font-medium text-sm mb-2">Management Contacts</h5>
              <ul className="space-y-1.5 text-xs text-gray-400">
                <li className="flex items-center gap-2">
                  <Mail size={12} className="text-[#FF6B00] flex-shrink-0" />
                  <a href="mailto:info@ycpschool.com" className="hover:text-white">info@ycpschool.com</a>
                </li>
                <li className="flex items-center gap-2">
                  <Mail size={12} className="text-[#FF6B00] flex-shrink-0" />
                  <a href="mailto:admin@ycpschool.com" className="hover:text-white">admin@ycpschool.com</a>
                </li>
                <li className="flex items-center gap-2">
                  <Mail size={12} className="text-[#FF6B00] flex-shrink-0" />
                  <a href="mailto:billing@ycpschool.com" className="hover:text-white">billing@ycpschool.com</a>
                </li>
                <li className="flex items-center gap-2 mt-2">
                  <Globe size={12} className="text-[#FF6B00] flex-shrink-0" />
                  <a href="https://www.ycpschool.com" target="_blank" rel="noopener noreferrer" className="hover:text-white">www.ycpschool.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; 1970 Young Christian Preparatory School/ JHS. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
